import { render, staticRenderFns } from "./dialog-prompt.mpx?vue&type=template&id=2d4e57be&isComponent&outputPath=components%2Fdialog-prompt424b6f25%2Findex"
import script from "./dialog-prompt.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdialog-prompt424b6f25%2Findex"
export * from "./dialog-prompt.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdialog-prompt424b6f25%2Findex"
import style0 from "./dialog-prompt.mpx?vue&type=style&index=0&id=2d4e57be&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_424b6f25%22%7D&isComponent&outputPath=components%2Fdialog-prompt424b6f25%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports